<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.downloadResults}}</h3>
</div>
<div class="modal-body">
    <form class="form-signin" style="max-width:400px">
        <div class="form-group">
            <div class="">
                <label for="name">{{LOCALIZATION.name}}</label>
                <input type="text" [(ngModel)]='input.name' id="name" name="name" class="form-control" placeholder="{{LOCALIZATION.name}}" required autofocus>
            </div>
        </div>
        <div class="form-group">
            <div class="">
                <label for="downloadType">{{LOCALIZATION.download}} {{LOCALIZATION.type}}</label>
                <select id="downloadType" name="downloadType" class="form-control" placeholder="Download Type"
                	 required autofocus [(ngModel)]="input.type" (ngModelChange)="setFormBasedOnType(input.type)">
                    <option value="PRODUCT" selected>{{LOCALIZATION.sourceOnly}}</option>
                    <option value="PRODUCT_INCLUDE_PDF">Source with PDF (if attached)</option>
                    <option value="METADATA">{{LOCALIZATION.metadataOnly}}</option>
                    <option value="PRODUCT_AND_METADATA">{{LOCALIZATION.sourceAndMetadata}}</option>
                    <option value="PRODUCT_AND_METADATA_INCLUDE_PDF">Source And Metadata With PDF (if attached)</option>
                </select>
            </div>
        </div>
        <div class="form-group">    
            <div [hidden]="!showMetadataType" class="metadata-type-div">
                <label for="metadataType">{{LOCALIZATION.metadata}} {{LOCALIZATION.type}}</label>
                <select id="metadataType" name="metadataType" class="form-control" placeholder="Metadata Type"
                	 [(ngModel)]="input.metadataType" (ngModelChange)="setFormBasedOnMetadataType(input.metadataType)">
                    <option value="METADATA_XML">{{LOCALIZATION.xml}}</option>
                    <option value="METADATA_KEY">{{LOCALIZATION.key}}</option>
                    <option value="METADATA_CSV">{{LOCALIZATION.csv}}</option>
                    <option value="METADATA_DC">{{LOCALIZATION.dc}}</option>
                    <option value="METADATA_MARC21">{{LOCALIZATION.marc21xml}}</option>
                </select>
            </div>
        </div>
        <div class="form-group">    
            <div [hidden]="!showFlattenOutput" class="flatten-output-div">
                <span id="flattenOutputLabel" 
                	style="font-weight:700; display:inline-block; max-width:100%; margin-bottom:5px; font-weight:700;">
                	{{LOCALIZATION.downloadSingleDirectory}}: 
                </span>
				<div class="toggle-switch" style="padding-top: 4px;">
					<input id="flattenOutput" name="flattenOutput" class="toggle-switch-toggle toggle-switch-toggle-round"
						 type="checkbox" [(ngModel)]="input.flattenOutput" aria-labelledby="flattenOutputLabel">
					<label for="flattenOutput"></label>
				</div>                
            </div>
        </div>        
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="download()" [disabled]="inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.download}}
    </button>
</div>
